import React, { useEffect, useState } from "react";
import { useLanguage, useT } from "@/lib/LanguageContext";
import { SUPPORTED_LANGS } from "../../../i18n";
import CrmTextarea from "../ui/CrmTextarea";
import CrmTabs from "../ui/CrmTabs";
import { LABEL } from "../ui/classes";
import { CRM } from "../../../constants/testIds/crm";

/**
 * The editable consent text, one draft per locale (`{fr, en, es}`, design §E.4):
 * `{practice_name}` is a merge token, never translated copy, so it survives every
 * language's text untouched. Saves ON BLUR, per field — the caller decides what "saved"
 * means (autosave via `PUT /api/crm/forms/{id}`).
 */
export default function ConsentTextField({ value, onSave }) {
  const t = useT("crm");
  const { lang: uiLang } = useLanguage();
  const [tab, setTab] = useState(SUPPORTED_LANGS.includes(uiLang) ? uiLang : SUPPORTED_LANGS[0]);
  const [draft, setDraft] = useState(value || {});

  useEffect(() => { setDraft(value || {}); }, [value]);

  const set = (lang, text) => setDraft((d) => ({ ...d, [lang]: text }));
  const blur = (lang) => { if (draft[lang] !== (value || {})[lang]) onSave({ ...(value || {}), [lang]: draft[lang] }); };

  return (
    <div>
      <label className={LABEL}>{t("forms.consentText")}</label>
      <CrmTabs
        label={t("forms.consentText")}
        value={tab}
        onChange={setTab}
        tabs={SUPPORTED_LANGS.map((l) => ({ key: l, label: l.toUpperCase() }))}
      />
      <div className="mt-2">
        {SUPPORTED_LANGS.map((l) => (l === tab && (
          <CrmTextarea
            key={l}
            rows={4}
            value={draft[l] || ""}
            onChange={(e) => set(l, e.target.value)}
            onBlur={() => blur(l)}
            data-testid={CRM.formsConsentText}
          />
        )))}
      </div>
    </div>
  );
}
